import { Controller } from 'stimulus';
import Recorder from 'recorder-js';

export default class extends Controller {
  recordedData = [];
  audioCtx = null;
  audioNode = null;
  audioInput = null;

  isRecording = false;
  blob = null;
  recorder = null;

  micAccess = () => {
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    this.recorder = new Recorder(audioContext, {
      // An array of 255 Numbers
      // You can use this to visualize the audio stream
      // If you use react, check out react-wave-stream
      // onAnalysed: data => console.log(data),
    });
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => this.recorder.init(stream))
      .catch((err) => console.log('Uh oh... unable to get stream...', err));
  };

  startRecording = () => {
    this.recorder.start().then(() => (this.isRecording = true));
  };

  stopRecording = () => {
    this.recorder.stop().then(({ blob, buffer }) => (this.blob = blob));
  };
}
